/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Otp_Purpose_Verify_EmailInputs */

const th_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยันอีเมลของคุณ`)
};

const en_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verify your email address`)
};

const ja_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスを確認する`)
};

const zh_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证你的邮箱地址`)
};

const es_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verificar tu dirección de correo`)
};

const pt_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verificar seu endereço de e-mail`)
};

const id_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`memverifikasi alamat email Anda`)
};

const fr_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vérifier votre adresse e-mail`)
};

const tl_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beripikahin ang email address mo`)
};

const vi_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`xác minh địa chỉ email của bạn`)
};

const ko_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소를 인증할`)
};

const de_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deine E-Mail-Adresse bestätigen`)
};

const ru_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`подтвердить ваш адрес почты`)
};

const tr_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-posta adresinizi doğrulamak`)
};

const it_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verificare il tuo indirizzo email`)
};

const pl_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zweryfikować adres e-mail`)
};

const uk_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`підтвердити вашу адресу пошти`)
};

const hi_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना ईमेल पता सत्यापित करने`)
};

const ar_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`توثّق بريدك الإلكتروني`)
};

const ms_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mengesahkan alamat e-mel anda`)
};

const bn_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার ইমেল ঠিকানা যাচাই করার`)
};

const zh_tw2_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`驗證你的電子郵件位址`)
};

const zh_hk2_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`驗證你的電子郵件位址`)
};

const ur_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اپنا ای میل پتہ تصدیق کرنے`)
};

const fa_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأیید نشانی ایمیل‌تان`)
};

const sw_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kuhakiki anwani yako ya barua pepe`)
};

const nl_email_otp_purpose_verify_email = /** @type {(inputs: Email_Otp_Purpose_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`je e-mailadres te bevestigen`)
};

/**
* | output |
* | --- |
* | "verify your email address" |
*
* @param {Email_Otp_Purpose_Verify_EmailInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_otp_purpose_verify_email = /** @type {((inputs?: Email_Otp_Purpose_Verify_EmailInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Otp_Purpose_Verify_EmailInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_otp_purpose_verify_email(inputs)
	if (locale === "ja") return ja_email_otp_purpose_verify_email(inputs)
	if (locale === "zh") return zh_email_otp_purpose_verify_email(inputs)
	if (locale === "es") return es_email_otp_purpose_verify_email(inputs)
	if (locale === "pt") return pt_email_otp_purpose_verify_email(inputs)
	if (locale === "id") return id_email_otp_purpose_verify_email(inputs)
	if (locale === "fr") return fr_email_otp_purpose_verify_email(inputs)
	if (locale === "tl") return tl_email_otp_purpose_verify_email(inputs)
	if (locale === "vi") return vi_email_otp_purpose_verify_email(inputs)
	if (locale === "ko") return ko_email_otp_purpose_verify_email(inputs)
	if (locale === "de") return de_email_otp_purpose_verify_email(inputs)
	if (locale === "ru") return ru_email_otp_purpose_verify_email(inputs)
	if (locale === "tr") return tr_email_otp_purpose_verify_email(inputs)
	if (locale === "it") return it_email_otp_purpose_verify_email(inputs)
	if (locale === "pl") return pl_email_otp_purpose_verify_email(inputs)
	if (locale === "uk") return uk_email_otp_purpose_verify_email(inputs)
	if (locale === "hi") return hi_email_otp_purpose_verify_email(inputs)
	if (locale === "ar") return ar_email_otp_purpose_verify_email(inputs)
	if (locale === "ms") return ms_email_otp_purpose_verify_email(inputs)
	if (locale === "bn") return bn_email_otp_purpose_verify_email(inputs)
	if (locale === "zh-TW") return zh_tw2_email_otp_purpose_verify_email(inputs)
	if (locale === "zh-HK") return zh_hk2_email_otp_purpose_verify_email(inputs)
	if (locale === "ur") return ur_email_otp_purpose_verify_email(inputs)
	if (locale === "fa") return fa_email_otp_purpose_verify_email(inputs)
	if (locale === "sw") return sw_email_otp_purpose_verify_email(inputs)
	if (locale === "nl") return nl_email_otp_purpose_verify_email(inputs)
	return en_email_otp_purpose_verify_email(inputs)
});